module.exports = __webpack_public_path__ + "img/not-allowed.599b698b.svg";